import React from 'react';
import {
  DrawerMenuContainer,
} from '@its/components/lib/Container components/DrawerMenuContainer/DrawerMenuContainer';
import Page from '@its/components/lib/Presentational components/Pages/Page/Page';
import {
  setAppBar,
} from '@its/components/lib/Container components/DrawerMenuContainer/actions';

export default class extends React.Component {

  static propTypes = {
    children: React.PropTypes.any,
  }

  static contextTypes = {
    store: React.PropTypes.object.isRequired,
  }

  static defaultProps = {
    children: undefined,
  }

  constructor(props, context) {
    super(props, context);
    this.context.store.dispatch(setAppBar({
      title: 'DISPLAY_MANAGER',
      navigateBack: false,
    }));
  }

  render() {
    return (
      <div>
        <DrawerMenuContainer />
        <Page>
          { this.props.children }
        </Page>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Util/Menu.js
 **/